// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGSuccess = props => /*#__PURE__*/_jsx("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M29.92 2.58L11.33 21.17l-9.25-9.25c-.362-.362-.862-.586-1.415-.586-1.105 0-2.001.896-2.001 2.001 0 .553.224 1.053.586 1.415L9.92 25.41c.362.362.862.587 1.415.587s1.053-.224 1.415-.587l20-20c.362-.362.586-.862.586-1.415 0-1.105-.896-2.001-2.001-2.001-.553 0-1.053.224-1.415.586z"
  })
}));
SVGSuccess.displayName = 'SVGSuccess';
export default SVGSuccess;